import { gradientGrainStyling } from "$/util/background";
import { StarRounded } from "@mui/icons-material";
import { Box, Card, CardContent, Container, Grid, Typography } from "@mui/material";
import React from "react";

interface Review {
  quote?: React.ReactNode;
  signature?: string;
  mobileOrder: number;
  img?: string;
  alt?: string;
}

const REVIEWS: Review[] = [
  {
    quote: (
      <>
        To be completely honest, it is one of, if not{" "}
        <strong>the best art AI I have ever used. </strong>
        It works so well that my friend is even getting a tattoo of an image made by it.
      </>
    ),
    signature: "Derek J.",
    mobileOrder: 1,
  },
  {
    img: "https://sb.blackink.ai/storage/v1/object/public/creations/d2f6e2aa-36bd-4624-b9f3-3a747046cd90/5b4d3eef-b208-4c8b-93e6-920b1be73a46_3.webp",
    alt: "Black and Gray Roses with Red Accent Tattoo",
    mobileOrder: 2,
  },
  {
    quote: (
      <>
        I&apos;m already quite a big fan of the app, I&apos;ve been searching for
        something like this to help me find a design that feels{" "}
        <strong>100% right for me.</strong>
      </>
    ),
    signature: "Filippa M.",
    mobileOrder: 4,
  },
  {
    img: "https://img.blackink.ai/tattoos/9bTVQcJhE5YH7CKd5cXSu2/crowned-lion-face-0.webp",
    alt: "Crowned Lion Face Tattoo",
    mobileOrder: 3,
  },
  {
    img: "https://img.blackink.ai/tattoos/DBzEdfYefGJFxY6p3UstR/rotting-toxic-mushrooms-melting-0.webp",
    alt: "Rotting Toxic Mushrooms Melting Tattoo",
    mobileOrder: 6,
  },
  {
    quote: (
      <>
        I said I would do it. <strong>Thanks for this marvelous tool</strong>...
        AI-generated tattoos, copy-pasted to my body thanks to BlackInk AI.
      </>
    ),
    signature: "Marina R.",
    mobileOrder: 5,
  },
  {
    img: "https://img.blackink.ai/tattoos/5PHkM1mEDp3dQPJuuuVEyV/norse-tree-of-life-0.webp",
    alt: "Norse Tree of Life Tattoo",
    mobileOrder: 7,
  },
  {
    quote: (
      <>
        <strong>Definitely using this</strong> for my next tattoo!
      </>
    ),
    signature: "Michael N.",
    mobileOrder: 8,
  },
];

export default function HomeTestimonialsSection() {
  return (
    <Container>
      <Typography variant="overline" color="inherit">
        What Our Customers Are Saying
      </Typography>
      <Typography variant="h2" fontWeight={500} color="inherit">
        Testimonials
      </Typography>
      <Grid
        container
        spacing={2}
        sx={{
          mt: 1,
          mb: 4,
          overflowX: { xs: "auto", md: "hidden" },
          flexWrap: { xs: "nowrap", md: "wrap" },
        }}
      >
        {REVIEWS.map((review, index) =>
          review.img ? (
            <Grid
              item
              xs={9}
              md={3}
              key={index}
              order={{ xs: review.mobileOrder, md: index }}
              sx={{
                flexShrink: 0,
                width: { xs: "250px", md: "auto" },
              }}
            >
              <Card
                sx={{
                  backgroundColor: "#F2F2F2",
                  color: "white",
                  borderRadius: 3,
                  height: "100%",
                }}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    height: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={review.img}
                    alt={review.alt}
                    style={{
                      width: "100%",
                      filter: "brightness(0.95)",
                    }}
                  />
                </CardContent>
              </Card>
            </Grid>
          ) : (
            <Grid
              item
              xs={9}
              md={3}
              key={index}
              order={{ xs: review.mobileOrder, md: index }}
              sx={{
                flexShrink: 0,
                width: { xs: "250px", md: "auto" },
              }}
            >
              <Card
                sx={{
                  ...gradientGrainStyling,
                  p: { xs: 1, md: 2 },
                  color: "white",
                  borderRadius: 3,
                  textAlign: "center",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <CardContent>
                  <Box color="#F7C334">
                    <StarRounded />
                    <StarRounded />
                    <StarRounded />
                    <StarRounded />
                    <StarRounded />
                  </Box>
                  <Typography variant="body1">{review.quote}</Typography>
                  <Typography variant="body1" sx={{ marginTop: 1 }} color="#AAA5FF">
                    <em>{review.signature}</em>
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ),
        )}
      </Grid>
    </Container>
  );
}
